export { Z_INDEXES } from 'src/constants/z-indexes';

export const EXTENDED_VIEW_CHILD_MAX_WIDTH = '40rem';

export const componentsFontSizes = { coloredAvatar: '0.55rem', input: '0.8rem' };
